import { useEffect, useState } from 'react'
import sbfLogo from '../../assets/SBF-Logo-1.png'
import bg from '../../assets/bg/3840x2160-desktop.png'
import useApp from '../../hooks/useAppContext'
import { formatarDiaHora } from '../../services/conversaoTimer'
import './portal-patrocinador.css'

const PortalPatrocinador = () => {
  const { getDocs, addClickDoc } = useApp()
  const [itens, setItens] = useState([{ descricao: 'teste' }])

  useEffect(() => {
    handleItens()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleItens = async () => {
    let aux_docs = await getDocs()
    setItens(aux_docs)
  }
  const handleClick = (id) => {
    addClickDoc(id)
  }

  return (
    <div className="container-patrocinador">
      <div className="barra-header"></div>
      <img src={bg} alt="SBF" id="bg-fundo-patrocinadores" />
      <img src={sbfLogo} alt="SBF" className="logo-agradecimento" />
      <div
        style={{
          width: '86%',
          marginTop: '25px',
          fontSize: '19px',
          textAlign: 'center',
          paddingBottom: '65px',
        }}
      >
        <div style={{ color: "#FFF" }}>
          <h4>Portal do Patrocinador</h4>
          <br />
          <a 
            href="https://portal.informamarkets.com.br/" 
            target="_blank" 
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              padding: '12px 24px',
              backgroundColor: '#0d8133',
              color: '#fff',
              textDecoration: 'none',
              borderRadius: '6px',
              fontWeight: '600',
              fontSize: '16px',
              transition: 'background-color 0.3s ease',
              boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#0a6b2a'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#0d8133'}
          >
            Acesse o Portal Informa Markets
          </a>
        </div>
      </div>
    </div>
  )
}
export default PortalPatrocinador
